import { rankingData } from '@/mocks/home';

const changeIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-foreground-400',
  new: 'ri-sparkling-line text-accent-500',
};

const rankColors = ['text-accent-500', 'text-primary-500', 'text-accent-500'];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            爆料热度榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            综合阅读量、评论数和分享数的实时热度排行。榜单每小时更新一次，看看你的瓜有没有上榜。
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
          {rankingData.map((item, idx) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                const target = document.querySelector('#cards');
                if (target) {
                  const headerHeight = 64;
                  const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
                  window.scrollTo({ top: targetPosition, behavior: 'smooth' });
                }
              }}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                idx < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className="w-8 md:w-10 flex-shrink-0 text-center">
                <span
                  className={`font-heading text-lg md:text-xl font-black ${
                    idx < 3 ? rankColors[idx] : 'text-foreground-400'
                  }`}
                >
                  {item.rank}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-sm md:text-base font-medium text-foreground-800 line-clamp-1">
                  {item.title}
                </span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
                <span className="text-xs md:text-sm font-semibold text-foreground-600 whitespace-nowrap">
                  {item.heat}
                </span>
                <i
                  className={`${changeIcons[item.change] || ''} text-sm`}
                ></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}